export enum AptProductStatus {
    Definitive = 'Definitivo',
    Temporary = 'Provvisorio',
    Cancelled = 'Annullato',
}
